import { render, staticRenderFns } from "./dprList.vue?vue&type=template&id=02dc3f28&"
import script from "./dprList.vue?vue&type=script&lang=js&"
export * from "./dprList.vue?vue&type=script&lang=js&"
import style0 from "./dprList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports